module.exports = __webpack_public_path__ + "media/images/bus/steering_wheel-a2377a722dddc8fb8059043dd12231a4.svg";